import React, { useRef } from "react"
import { IconButton, TextField, Tooltip } from "@material-ui/core"
import { Link as LinkIcon, Assignment } from "@material-ui/icons"
import Config from "react-global-configuration"
import { useSnackbar } from "../SnackbarProvider"

const CopyLinkButton = ({ children, link }) => {
  const inputRef = useRef(null)
  const { showMessage } = useSnackbar()
  const config = Config.get()
  const url = link || `${config.clientLinkBaseUri || config.clientBaseUri}${window.location.pathname}`

  const handleClick = () => {
    inputRef.current.select()
    document.execCommand("copy")
    showMessage({ message: "Link copied to your clipboard", icon: <Assignment /> })
    inputRef.current.blur()
  }

  return (
    <>
      <Tooltip title="Copy link" placement="top">
        <IconButton onClick={handleClick}>{children || <LinkIcon />}</IconButton>
      </Tooltip>
      <TextField
        inputRef={inputRef}
        value={url}
        style={{
          left: 0,
          bottom: 0,
          width: 1,
          height: 1,
          opacity: 0,
          position: "fixed",
        }}
      />
    </>
  )
}

export { CopyLinkButton }
